import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { printQuotedmgc3s3pgfors as printQuoted } from './StringOps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonToStringWriterClass;
function JsonToStringWriter() {
  if (JsonToStringWriterClass === VOID) {
    class $ {
      constructor() {
        this.d2m_1 = StringBuilder().tb(128);
      }
      h2q(value) {
        this.d2m_1.sg(value);
      }
      b2q(char) {
        this.d2m_1.o1(char);
      }
      d2q(text) {
        this.d2m_1.m1(text);
      }
      n2q(text) {
        printQuoted(this.d2m_1, text);
      }
      e2m() {
        this.d2m_1.vg();
      }
      toString() {
        return this.d2m_1.toString();
      }
    }
    initMetadataForClass($, 'JsonToStringWriter', JsonToStringWriter);
    JsonToStringWriterClass = $;
  }
  return JsonToStringWriterClass;
}
//region block: exports
export {
  JsonToStringWriter as JsonToStringWriter25agxcyem0yhk,
};
//endregion

//# sourceMappingURL=JsonToStringWriterJsWasm.mjs.map
